// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionDropdown_wrapper__P6ZUJ","actionIcon":"ActionDropdown_actionIcon__rFKTk"};